import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { resetAppPropsAction, resetUserPropsAction } from '../../store/actions';
import { Routes } from '../../shared/routes';

const Logout = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.app);

  useEffect(() => {
    dispatch(resetAppPropsAction());
    dispatch(resetUserPropsAction());
  }, [dispatch]);

  if (!isAuthenticated) {
    return <Redirect to={Routes.Login} />;
  }

  return <div>{t('logout')}</div>;
};

export default Logout;
